{
  "en": {
    "activities": {
      "labels": {
        "noProject": "No project"
      }
    },
    "alerts": {
      "exampleButton": "Insert example"
    },
    "appsInfo": {
      "shared": {
        "generalFeedback": "General feedback",
        "introduction": "This tool offers you many possibilities of use for school and lessons:",
        "toolSpecificFaqs": "Questions about the tool {name}",
        "videoTutorial": "Watch here how the tool works"
      }
    },
    "authorInfoModal": {
      "creativeCommons": "They are licensed under the <a href='https://creativecommons.org/licenses/by/4.0/' target='_BLANK'>Creative Commons license CC-BY 4.0</a>.",
      "header": "About this content",
      "listHeader": "You are free to:",
      "listHtmlPublic": "<li><i class=\"bi bi-check2\"></i><strong>Share</strong> — reproduce and redistribute this content in any format or medium.</li>\n<li><i class=\"bi bi-check2\"></i><strong>Edit</strong> — remix, alter and build upon this content for any purpose, even for commercial use.</li>\n<li><i class=\"bi bi-exclamation-triangle\"></i>With further processing, you undertake to <strong>provide appropriate copyright information</strong> and to <strong>name {name}</strong> as the author. These conditions are automatically met during further processing within the fobizz Tools.</li>",
      "paragraphHtmlIntro": "This content was created by <strong>{name}</strong> using the <a href=\"https://app.fobizz.com/\" target=\"_blank\">fobizz Tools</a>.",
      "paragraphHtmlPrivate": "This content may be shared, reproduced or redistributed <strong>only with the expressed consent of {name}</strong>.",
      "paragraphHtmlPrivateHead": "This content has only been released to <strong>specific people</strong> via access link.",
      "paragraphHtmlPublic": "This content was created based on the content of <a href='{link}' target='_BLANK'><strong>{name}</strong></a>."
    },
    "buttons": {
      "add": "Add",
      "apply": "Apply",
      "cancel": "Cancel",
      "chooseFile": "Choose File",
      "clearSearch": "Clear search",
      "close": "Close",
      "copy": "Copy",
      "copySmall": "copy",
      "createContent": "Content Creation",
      "delete": "Delete",
      "deleteImage": "Delete image",
      "edit": "Edit",
      "enableRecordingDevice": "Enable recording device",
      "finished": "Finished",
      "generatePreviewImage": "Generate Image",
      "generateSuggestion": "Generate suggestion",
      "generateText": "Generate text",
      "go": "Let's go",
      "insert": "Insert",
      "insertElement": "Insert element",
      "loadMore": "Load more",
      "move": "Move",
      "next": "Next",
      "previous": "Back",
      "reRecord": "Re-record",
      "reload": "Reload",
      "save": "Save",
      "select": "Select",
      "startRecording": "Start recording",
      "stopRecording": "Stop recording",
      "submit": "Submit",
      "toggleFilterMenu": "Toggle filter menu",
      "tryAgain": "Try again",
      "understood": "Got it",
      "uploadAnotherFile": "Upload another file",
      "uploadFile": "Upload file",
      "useToolsUnlimited": "Use fobizz unlimited",
      "no": "No",
      "yes": "Yes"
    },
    "confirmDialog": {
      "discardItem": {
        "confirm": "Move",
        "text": "The content ({modelName}) will be removed from your overview. You can find it in the trash afterwards.",
        "title": "Move content to trash?"
      },
      "promptCheckCancel": "Revise",
      "promptContentFilter": {
        "confirm": "Send",
        "text": "Our security filters have classified your input as sensitive. You can adjust it or send it unchanged.",
        "title": "Input blocked"
      },
      "promptPrivacy": {
        "confirm": "Send",
        "text": "Your prompt appears to contain personal data. When submitted, it will be transmitted to the AI.",
        "title": "Personal data in prompt?"
      }
    },
    "courses": {
      "labels": {
        "completed": "Completed",
        "course": "Self-study course",
        "enrolled": "Enrolled",
        "impulse": "Micro lesson",
        "recording": "Recording",
        "webinar": "Webinar",
        "workshop": "Workshop",
        "b2bWorkshop": "Internal"
      }
    },
    "emptyState": {
      "ai": {
        "noHistoryDescription": "Feel free to generate new content with the AI Assistant.",
        "noHistoryTitle": "You did not create any content yet."
      }
    },
    "enums": {
      "autoCleanup": {
        "day": "1 Day",
        "month": "1 Month",
        "months_18": "18 Months",
        "never": "Never",
        "week": "1 Week",
        "year": "1 Year"
      },
      "companyKinds": {
        "kind_school": "School",
        "kind_community_college": "Community College",
        "kind_other": "Other",
        "kind_teacher_training": "Teacher training course",
        "kind_institute": "Professional development",
        "kind_media_center": "Media Center",
        "kind_college": "University/College",
        "kind_company": "Company/Organization",
        "kind_government_agency": "Government Agency",
        "kind_national_license": "National License",
        "kind_goethe_institute": "Goethe Institute",
        "kind_supporting_institution": "Supporting Institution",
        "kind_tutoring": "Tutoring",
        "kind_language_school": "Language School"
      },
      "courseTargetGroupTypes": {
        "TARGET_GROUP_TYPE_TEACHERS": "Educators",
        "TARGET_GROUP_TYPE_SCHOOL_BOARDS": "Principals",
        "TARGET_GROUP_TYPE_SCHOOL_EXECUTIVES": "Teachers in leading position",
        "TARGET_GROUP_TYPE_TEACHER_TRAINEES": "University students",
        "TARGET_GROUP_TYPE_STUDENT_TEACHERS": "Teacher trainees",
        "TARGET_GROUP_TYPE_SCHOOL_LEADERS": "School leaders"
      },
      "gradeLevels": {
        "GRADE_LEVEL_1_2": "1st/2nd grade",
        "GRADE_LEVEL_3_4": "3rd/4th grade",
        "GRADE_LEVEL_HIGH": "Upper school",
        "GRADE_LEVEL_LOWER": "Lower school",
        "GRADE_LEVEL_MIDDLE": "Middle school"
      },
      "international": {
        "false": "German-speaking school system",
        "true": "English-speaking school system"
      },
      "itemNodes": {
        "AudioRecorder::File": "Audio Recording",
        "LinkShortener::Link": "URL Shortener",
        "ScreenRecorder::File": "Screen Recording",
        "Tools::Ai::Assistant": "AI Assistant",
        "Tools::Ai::Converter": "Content",
        "Tools::Ai::Feedback": "Grading Assistant",
        "Tools::Ai::Image": "AI Image",
        "Tools::ClassroomScreen::Screen": "Teaching Board",
        "Tools::FileSharing::File": "File Sharing",
        "Tools::Pinboard::Board": "Pinboard",
        "Tools::Pinboard::Card": "Pinboard",
        "Tools::Pinboard::Comment": "Pinboard",
        "Tools::Pinboard::List": "Pinboard",
        "Tools::PupilFeedback::Assignment": "AI for Feedback",
        "Tools::PupilFeedback::Feedback": "AI for Feedback",
        "Tools::Surveys::Survey": "Survey",
        "Tools::Surveys::SurveyResponse": "Survey",
        "Tools::TextEditor::Document": "Text Document",
        "Tools::Website::Page": "Website",
        "Tools::WordClouds::WordCloud": "Wordcloud",
        "Tools::WordClouds::WordEntry": "Word Cloud",
        "Tools::Worksheet::Response": "Response",
        "Tools::Worksheet::Worksheet": "Worksheet",
        "VideoRecorder::File": "Video Recording",
        "folder": "Folder"
      },
      "languages": {
        "de": "German",
        "en": "English",
        "es": "Spanish",
        "fr": "French",
        "it": "Italian",
        "nl": "Dutch",
        "ru": "Russian",
        "ua": "Ukrainian"
      },
      "privacyLevel": {
        "locked": "Blocked",
        "members_only": "Members only",
        "password_protected": "Password protected",
        "public_for_all": "Available as OER",
        "secret": "Visible"
      },
      "profileGradeTypes": {
        "GRADE_TYPE_ELEMENTARY_SCHOOL": "Elementary school",
        "GRADE_TYPE_LOWER_GRADE": "Lower grade",
        "GRADE_TYPE_MIDDLE_LEVEL": "Middle grade",
        "GRADE_TYPE_OTHER": "Other",
        "GRADE_TYPE_SPECIAL_SCHOOL": "Special school",
        "GRADE_TYPE_UPPER_SCHOOL": "Upper grade",
        "GRADE_TYPE_VOCATIONAL_SCHOOL": "Vocational school"
      },
      "schoolTypes": {
        "SCHOOL_TYPE_ACADEMIC_HIGH_SCHOOL": "Academic High School",
        "SCHOOL_TYPE_COMPREHENSIVE_SCHOOL": "Comprehensive School",
        "SCHOOL_TYPE_CUSTOM": "Custom",
        "SCHOOL_TYPE_ELEMENTARY_SCHOOL": "Elementary School",
        "SCHOOL_TYPE_MAIN_SCHOOL": "Main School",
        "SCHOOL_TYPE_MIDDLE_SCHOOL": "Middle School",
        "SCHOOL_TYPE_SECONDARY_SCHOOL": "Secondary School",
        "SCHOOL_TYPE_SPECIAL_SCHOOL": "Special School",
        "SCHOOL_TYPE_UNIVERSITY": "University",
        "SCHOOL_TYPE_VOCATIONAL_SCHOOL": "Vocational School"
      },
      "subjectTypes": {
        "SUBJECT_TYPE_ART": "Art",
        "SUBJECT_TYPE_BIOLOGY": "Biology",
        "SUBJECT_TYPE_CHEMISTRY": "Chemistry",
        "SUBJECT_TYPE_COMPUTER_SCIENCE": "Computer Science",
        "SUBJECT_TYPE_ECONOMY": "Economy",
        "SUBJECT_TYPE_ENGLISH": "English",
        "SUBJECT_TYPE_ESL": "GSL/GFL",
        "SUBJECT_TYPE_ETHICS": "Ethics",
        "SUBJECT_TYPE_FOREIGN_LANGUAGES": "Language Teaching",
        "SUBJECT_TYPE_GEOGRAPHIE": "Geography",
        "SUBJECT_TYPE_GERMAN": "German",
        "SUBJECT_TYPE_HISTORY": "History",
        "SUBJECT_TYPE_MATH": "Math",
        "SUBJECT_TYPE_MEDIA": "Media",
        "SUBJECT_TYPE_MUSIC": "Music",
        "SUBJECT_TYPE_NATURAL_SCIENCES": "Natural Sciences",
        "SUBJECT_TYPE_OTHER": "Other",
        "SUBJECT_TYPE_PERSONAL_EDUCATION": "Personal Education",
        "SUBJECT_TYPE_PHILOSOPHIE": "Philosophy",
        "SUBJECT_TYPE_PHYSICS": "Physics",
        "SUBJECT_TYPE_POLITICS": "Politics",
        "SUBJECT_TYPE_RELIGION": "Religion",
        "SUBJECT_TYPE_SPORT": "Physical Education",
        "SUBJECT_TYPE_TECHNOLOGY": "Technology",
        "SUBJECT_TYPE_UNSPECIFIC": "Unspecified"
      }
    },
    "flash": {
      "addFileSuccess": "File {filename} added",
      "errorOccurred": "An error occurred. Please try again.",
      "premiumLimitWarning": "Only one Premium request left for today | Only {count} Premium requests left for today",
      "premiumLimitResetsAtMidnight": "The limit resets at midnight.",
      "premiumLimitFallback": "Premium limit reached for today",
      "premiumLimitFallbackDescription": "{model} takes over until midnight.",
      "premiumLimitReached": "Premium limit reached for today",
      "premiumLimitReachedDescription": "You can use Premium models again from midnight.",
      "alreadyLoggedIn": "You are already logged in",
      "bookmarkSuccess": "Added to bookmarks",
      "bookmarkSuccessLink": "Go to bookmarks",
      "connectionReestablished": "Connection has been reestablished",
      "paidLicenseRequired": "You need a paid license for this feature",
      "remixStarted": "{name} is being remixed",
      "remixSuccess": "{name} created",
      "removeFileSuccess": "File {filename} removed",
      "successfullyCreated": "Successfully created",
      "successfullyDeleted": "Successfully deleted",
      "successfullyUpdated": "Successfully updated",
      "templateMarkSuccess": "{name} is marked as a template",
      "tooManyRequests": "Too many requests. Please try again in a few seconds.",
      "templateUnmarkSuccess": "{name} unmarked as template",
      "unbookmarkSuccess": "Removed from bookmarks",
      "undiscardItemSuccess": "\"{name}\" has been restored"
    },
    "footer": {
      "aboutUs": "About fobizz",
      "aiAndTools": "AI and Tools",
      "aiAndToolsHelp": "Help with Tools & AI Applications",
      "aiGuidelines": "AI Guidelines (EU AI Act)",
      "alternativeText": "Privacy badge which awards high and tested data protection",
      "certificatesHelp": "Help with Certificates",
      "company": "Company",
      "courses": "Professional Development",
      "coursesHelp": "Help with Courses and Webinars",
      "enrollmentHelp": "Help with Enrollment",
      "freeTrial": "Free Trial Access",
      "appStoreAriaLabel": "Download on the App Store",
      "getTheApp": "Get the app:",
      "googlePlayAriaLabel": "Get it on Google Play",
      "gettingStarted": "Tips for Getting Started with fobizz",
      "helpAndContact": "Help and Contact",
      "imprint": "Imprint",
      "jobs": "Jobs",
      "language": "Language",
      "legal": "Legal",
      "licenses": "Licenses",
      "newsletter": "Subscribe to our newsletter",
      "partners": "Our Partners",
      "partnersHelp": "Help with Partners",
      "privacyPolicy": "Privacy Policy",
      "schoolLicensePrices": "School and Group License Prices",
      "shareWithColleagues": "Share Content with Colleagues",
      "shareWithStudents": "Share Content with Students",
      "singleLicensePrices": "Single License Prices",
      "tAndC": "T&C",
      "teachingMaterial": "Teaching Material",
      "teachingMaterialHelp": "Help with Teaching Materials",
      "team": "Team",
      "technicalHelp": "First Aid for Technical Issues",
      "toTeach": "fobizz and to teach",
      "urls": {
        "aboutUs": "https://fobizz.com/de/was-ist-fobizz/",
        "aiAndTools": "https://app.fobizz.com",
        "aiAndToolsHelp": "https://app.fobizz.com/de/help/categories/54-fobizz-tools",
        "aiGuidelines": "https://app.fobizz.com/de/help/categories/60-k-guidelines",
        "certificatesHelp": "https://app.fobizz.com/de/help/articles/78-weiterbildung-zertifikat-erhalten",
        "courses": "https://app.fobizz.com/fortbildungen",
        "coursesHelp": "https://app.fobizz.com/de/help/categories/50-fortbildungen",
        "enrollmentHelp": "https://app.fobizz.com/de/help/articles/311-kurs-einschreiben",
        "freeTrial": "https://app.fobizz.com/de/help/articles/310-fobizz-kostenfrei-testen",
        "gettingStarted": "https://app.fobizz.com/de/help/articles/133-start-empfehlungen",
        "helpAndContact": "https://app.fobizz.com/de/help",
        "imprint": "https://app.fobizz.com/imprints",
        "jobs": "https://fobizz.com/de/unsere-jobs/",
        "licenses": "https://app.fobizz.com/de/help/articles/273-kosten-fobizz",
        "newsletter": "https://fobizz.com/en/receive-the-latest-news-via-newsletter/",
        "partners": "https://app.fobizz.com/partners",
        "partnersHelp": "https://app.fobizz.com/de/help/categories/56-unsere-partner",
        "privacyPolicy": "https://app.fobizz.com/data_protections",
        "schoolLicensePrices": "https://app.fobizz.com/de/help/articles/102-schullizenz-preise-und-paketgroessen",
        "shareWithColleagues": "https://app.fobizz.com/en/help/articles/25-how-can-i-share-material-with-my-colleagues",
        "shareWithStudents": "https://app.fobizz.com/de/help/articles/20-inhalte-mit-schueler-innen-teilen",
        "singleLicensePrices": "https://app.fobizz.com/de/help/articles/279-abo-einzelizenz",
        "teachingMaterial": "https://app.fobizz.com/gallery",
        "teachingMaterialHelp": "https://app.fobizz.com/de/help/categories/59-unterrichtsmaterialien",
        "team": "https://fobizz.com/de/team/",
        "technicalHelp": "https://app.fobizz.com/de/help/categories/62-technische-probleme",
        "termsAndConditions": "https://app.fobizz.com/terms_and_conditions",
        "toTeach": "https://fobizz.com/de/to-teach/",
        "useToolsWithStudents": "https://app.fobizz.com/de/help/articles/309-tools-schueler-innen-nutzen"
      },
      "useToolsWithStudents": "Use Tools with Students"
    },
    "global": {
      "all": "All",
      "emptyFilterHeading": "Unfortunately, we could not find any suitable content.",
      "emptyFilterText": "Feel free to try again with a different search term or adjust your filters.",
      "filterContent": "Filter content",
      "resetFilter": "Reset Filter"
    },
    "headers": {
      "aiImageSearch": "My AI Images",
      "auto_cleanup": "Deletion settings",
      "background": "Background",
      "backgroundColor": "Background color",
      "backgroundPreview": "Background preview",
      "camera": "Camera",
      "colorAndPattern": "Color and pattern",
      "colors": "Colors",
      "editFolder": "Edit Folder",
      "files": "Files",
      "hint": "Hint",
      "image": "Image",
      "imageSearch": "Image search",
      "imageUploadHint": "You can now see it on the worksheet",
      "imageUploadSuccess": "Image uploaded successfully.",
      "images": "Images",
      "previewImage": "Preview Image",
      "latex": "LaTeX",
      "link": "Link",
      "microphone": "Microphone",
      "patterns": "Patterns",
      "recording": "Recording",
      "settings": "Settings",
      "share": "Share",
      "statistics": "Statistics",
      "toolSpecificFaqs": "Questions about the tool {name}",
      "videoTutorial": "Watch here how the tool works",
      "views": "Total views",
      "visitorPermissions": "Visitor permission"
    },
    "feedback": {
      "thumbsDown": "Dislike",
      "thumbsUp": "Like"
    },
    "help": {
      "autoCleanup": {
        "day": "Data will not be deleted after one day.",
        "month": "Data will not be deleted after one month.",
        "never": "Data will not be deleted automatically.",
        "week": "Data will not be deleted after one week."
      },
      "embed": "Copy the code snippet to embed it on other websites.",
      "jsRequired": "JavaScript is required",
      "maxCharacters": "Maximum {max} characters",
      "privacyLevel": {
        "locked": "Hide this content temporarily or retrospectively. Only you can view and edit it.",
        "members_only": "Not public. Only logged-in members have access.",
        "password_protected": "Further secure this content with a password.",
        "public_for_all": "Publish the content as OER in the fobizz gallery for teaching materials. <a href=\"/gallery/how_to\" target=\"_blank\">Learn more</a>",
        "secret": "Everyone with access can view and use this content."
      },
      "privacyLevelInLibrary": {
        "locked": "Hide the content. Only you and the teachers at your school can see it."
      },
      "visitorPermissions": {
        "visitor_permissions_invisible": "Visitors cannot view content.",
        "visitor_permissions_read": "Visitors can view content.",
        "visitor_permissions_write": "Visitors can edit content."
      }
    },
    "hints": {
      "allowedFileTypes": "Only certain file types are allowed",
      "converting": "File conversion in progress...",
      "copied": "Copied to clipboard",
      "creating": {
        "docx": "Creating Word document...",
        "pdf": "Creating PDF...",
        "pptx": "Creating PowerPoint presentation..."
      },
      "dataProtectionFileUpload": "Do not upload sensitive or personal information and respect the copyright when using content from others.",
      "dataProtectionFileUploadTitle": "Protect your data when uploading files",
      "dragDrop": "Hint: You can upload a file directly by dragging and dropping it here",
      "dragOrSelectFile": "Drag image here or",
      "dragOrSelectImage": "Drag image here or select",
      "imageUploading": "Image is being uploaded...",
      "drop": "Drop file here",
      "dropFile": "Drop file or",
      "embedIFrame": "By clicking on this preview image, you agree that the displayed content will be reloaded and that the necessary data, in particular your IP address, will be transmitted to the content provider. Further information can be found in our privacy policy.",
      "embedIFramePupil": "By clicking on this preview image, the displayed content will be reloaded and the necessary data, in particular your IP address, will be transmitted to the content provider. If in doubt, ask your teacher.",
      "exampleAlert": "What can that look like?",
      "exampleButton": "Insert example",
      "fileLimit": "(max. {size} MB)",
      "inputLabel": "Your prompt",
      "latexSyntax": "You can use <a href=\"https://katex.org/docs/supported\" target=\"_blank\">LaTeX Syntax</a>",
      "legacyBrowserBanner": "It seems that you are using an outdated browser. Please update your browser to be able to use our website to its full extent. An up-to-date browser will not only improve your security, but also the display and functionality of our website.",
      "loading": "Loading...",
      "maxFileSize": "Maximum {size} MB",
      "maxRecordingLength": "You can record up to 4 minutes at a time.",
      "noItems": "You haven't created anything yet. Start now!",
      "noOptions": "The list is empty",
      "noResults": "No results found",
      "notSpecified": "Not specified yet",
      "ready": {
        "docx": "Word document ready",
        "pdf": "PDF ready",
        "pptx": "PowerPoint presentation ready"
      },
      "previewImageDragDrop": "Drag image here or click to upload",
      "progressMessage": "Processing...",
      "progressMessageQueued": "In queue...",
      "prompt": "Important: Never share personal data with the AI and check the answers critically.",
      "selectFile": "Select file",
      "serverStatus": "Our tools are currently under heavy load and your requests may take longer than usual. Thank you for your patience. We're already working to get the system running at normal speed again",
      "settingsSaved": "Your settings have been saved.",
      "submittingDescription": "If it takes longer, the process is running in the background. You can do something else in the meantime and find the result in the history on the right.",
      "uploading": "File upload in progress...",
      "uploadingProgress": "Uploading file: {progress}",
      "visitorMaterial": "You are using fobizz as a guest. All content will be deleted after 2 days. <a href=\"{url}\" target=\"_blank\">Sign up now</a> to save your content."
    },
    "infoModal": {
      "classroom_screen": "<h3><strong>Lesson draft</strong></h3><table class=\"table table-bordered\"><tbody><tr><td colspan=\"1\" rowspan=\"1\"><p><strong>Topic</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>Name / subject of the lesson</em></p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p><strong>Recommended time</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>e.g. 45/90 minutes</em></p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p><strong>Learning goal</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>What is the primary goal of the lesson? What skill acquisition/growth should be achieved at the end of the lesson?</em></p></td></tr></tbody></table><p></p><h3><strong>Lesson outline</strong></h3><table class=\"table table-bordered\"><tbody><tr><td colspan=\"1\" rowspan=\"1\"><p><strong>Duration (min)</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><strong>Phase</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><strong>Lesson activities / teacher-student interaction</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><strong>Social form / work mode</strong></p></td><td colspan=\"1\" rowspan=\"1\"><p><strong>Media / material</strong></p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p><em>5</em></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>Introduction</em></p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p><em>10</em></p></td><td colspan=\"1\" rowspan=\"1\"><p><em>Preparation</em></p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td><td colspan=\"1\" rowspan=\"1\"><p>...</p></td></tr><tr><td colspan=\"1\" rowspan=\"1\"><p></p></td><td colspan=\"1\" rowspan=\"1\"><p></p></td><td colspan=\"1\" rowspan=\"1\"><p></p></td><td colspan=\"1\" rowspan=\"1\"><p></p></td><td colspan=\"1\" rowspan=\"1\"><p></p></td></tr></tbody></table><p></p><p><strong>Further information</strong></p><p><em>Description of the content and procedure of the teaching unit. Tips on how to conduct and prepare the lesson. If applicable, explanations on curriculum reference and didactic-methodical decisions.</em></p><p></p>",
      "title": "Additional information for teachers"
    },
    "labels": {
      "aiEnabled": "AI enabled",
      "authorName": "Author",
      "confirm": "Confirm",
      "continue": "Continue",
      "customSubjectType": "Custom subject type",
      "description": "Description",
      "notSpecified": "Not specified",
      "gradeLevels": "Grade levels",
      "imageSearch": {
        "categories": "Animals, Dinosaurs, Nature, Landscape, Beach, Sea, Sky, Space, Car, Objects, Fashion, Office, Children, People, Family, Stories",
        "noMoreResults": "No more images found"
      },
      "international": "Content for",
      "itemTotals": "{firstItem} - {lastItem} of {totalCount} entries",
      "language": "Language",
      "latex": "LaTeX Input",
      "loading": "Loading...",
      "name": "Name",
      "new": "New",
      "nextPage": "Next page",
      "page": "Page",
      "previousPage": "Previous page",
      "password": "Password",
      "peopleCount": "1 person | {count} people",
      "preview": "Preview",
      "pseudonym": "Insert your pseudonym or name abbreviation here.",
      "schoolTypes": "School types",
      "search": "Search",
      "subjectTypes": "Subject types",
      "title": "Title",
      "withAi": "With AI"
    },
    "languages": {
      "de": "German",
      "en": "English",
      "es": "Spanish",
      "fr": "French"
    },
    "limitUpsellBox": {
      "bodySubtitleHtml": "Recommend the <strong>fobizz school license</strong> to your colleagues or get the <strong>individual license</strong> just for you.",
      "bodyTitle": "Would you like to use fobizz unlimitedly?",
      "header": {
        "ai_assistant": {
          "multiple": "create <strong>{number} {more} AI Assistants</strong>",
          "one": "create <strong>one more AI Assistant</strong>"
        },
        "ai_chat": {
          "multiple": "have the AI Chat give you <strong>{number} {more} answers</strong>",
          "one": "have the AI Chat give you <strong>one more answer</strong>"
        },
        "ai_chat_completion": {
          "multiple": "have the AI Chat give you <strong>{number} {more} answers</strong>",
          "one": "have the AI Chat give you <strong>one more answer</strong>"
        },
        "ai_converter": {
          "multiple": "enter <strong>{number} {more} prompts</strong> with the AI Media Creation Tools",
          "one": "enter <strong>one more prompt</strong> with the AI Media Creation Tools"
        },
        "ai_document_qa": {
          "multiple": "upload <strong>{more} {number} documents</strong> to the PDF Chat",
          "one": "upload <strong>one more document</strong> to the PDF Chat"
        },
        "ai_feedback": {
          "multiple": "enter <strong>{number} {more} prompts</strong> to the AI Assistant for feedbacks",
          "one": "enter <strong>one more prompt</strong> to the AI Assistant for feedback"
        },
        "ai_image": {
          "multiple": "create <strong>{number} {more} images</strong>",
          "one": "create <strong>one more image</strong>"
        },
        "ai_mini_tool": {
          "multiple": "enter <strong>{number} {more} prompts</strong> in the Prompt Lab",
          "one": "enter <strong>one more prompt</strong> in the Prompt Lab"
        },
        "ai_persona": {
          "multiple": "enter <strong>{number} {more} prompts</strong> to the Character Chat",
          "one": "enter <strong>one more prompt</strong> to the Character Chat"
        },
        "audio_recorder": {
          "multiple": "record <strong>{number} {more} audio files</strong>",
          "one": "record <strong>one more audio file</strong>"
        },
        "classroom_screen": {
          "multiple": "create <strong>{number} {more} teaching boards</strong>",
          "one": "create <strong>one more teaching board</strong>"
        },
        "file_sharing": {
          "multiple": "share <strong>{number} {more} files</strong>",
          "one": "share <strong>one more file</strong>"
        },
        "licenseRequiredHtml": "<h2>You need a fobizz license to use this tool.</h2><p>Find out about our licences for unlimited use.</p>",
        "limitReachedHtml": "<h2>You have reached your monthly limit for this tool.</h2><p>Find out about our licences for unlimited use.</p>",
        "limitReachedVisitor": "You have used up your daily limit of responses from the AI assistant.",
        "link_shortener": {
          "multiple": "create <strong>{number} {more} short links</strong>",
          "one": "create <strong>one more short link</strong>"
        },
        "monthlyLimitNotReached": "You can {actionText} this month.",
        "monthlyLimitNotReachedVisitor": "As a guest, you can {actionText} this month.",
        "more": "more",
        "pinboard": {
          "multiple": "create <strong>{number} {more} pinboards</strong>",
          "one": "create <strong>one more pinboard</strong>"
        },
        "pupil_feedback": {
          "multiple": "create <strong>{number} {more} assignments</strong> with the AI for Feedback",
          "one": "create <strong>one more assignment</strong> with the AI for Feedback"
        },
        "qrcodes": {
          "multiple": "create <strong>{number} {more} QR codes</strong>",
          "one": "create <strong>one more QR code</strong>"
        },
        "registerNow": "<strong><a href=\"{url}\" target=\"_blank\">Create a free account</a></strong> to continue using the fobizz tools.",
        "school_classes": {
          "multiple": "create <strong>{number} {more} shared spaces</strong> to use with students",
          "one": "create <strong>one more shared space</strong> to use with students"
        },
        "screen_recorder": {
          "multiple": "create <strong>{number} {more} screen recordings</strong>",
          "one": "create <strong>one more screen recording</strong>"
        },
        "shared_space_link": {
          "multiple": "create <strong>{number} {more} shared spaces</strong>",
          "one": "create <strong>one more shared space</strong>"
        },
        "surveys": {
          "multiple": "create <strong>{number} {more} surveys</strong>",
          "one": "create <strong>one more survey</strong>"
        },
        "text_editor": {
          "multiple": "create <strong>{number} {more} text documents</strong>",
          "one": "create <strong>one more text document</strong>"
        },
        "video_recorder": {
          "multiple": "record <strong>{number} {more} videos</strong>",
          "one": "record <strong>one more video</strong>"
        },
        "website": {
          "multiple": "create <strong>{number} {more} websites</strong>",
          "one": "create <strong>one more website</strong>"
        },
        "word_clouds": {
          "multiple": "create <strong>{number} {more} word clouds</strong>",
          "one": "create <strong>one more word cloud</strong>"
        },
        "worksheet": {
          "multiple": "create <strong>{number} {more} worksheets</strong>",
          "one": "create <strong>one more worksheet</strong>"
        }
      },
      "activation": {
        "question": "Your institution already has a license?",
        "success": "License successfully activated! You are now a member of \"{groupTitle}\"."
      },
      "upsellCard": {
        "group": {
          "description": "The group license is already worthwhile for 5 people.",
          "linkText": "Info about group license",
          "linkUrl": "https://fobizz.com/en/",
          "title": "Together with colleagues"
        },
        "individual": {
          "description": "Discover all offers for you as an individual teacher.",
          "linkText": "Info about individual licenses",
          "linkUrl": "https://app.fobizz.com/profile/licenses",
          "title": "Individually for you"
        }
      }
    },
    "links": {
      "accept": "I have read the information",
      "aiAssistants": "AI Assistants",
      "aiImageSearch": "My AI Images",
      "back": "Back",
      "back_to_curriculum": "Back to curriculum",
      "clickToEdit": "Click to edit",
      "close": "Close",
      "copied": "Copied!",
      "copy": "Copy",
      "create": "Create",
      "createNew": "Create new",
      "createTool": "Create {name}",
      "createWithTemplate": "Create with template",
      "createWithoutTemplate": "Create",
      "dataProtection": "Data protection",
      "delete": "Delete",
      "discard": "Move to trash",
      "download": "Download",
      "downloadCSV": "Download as CSV",
      "duplicate": "Duplicate",
      "edit": "Edit",
      "exportAs": {
        "docx": "Export Word",
        "pdf": "Export PDF",
        "pptx": "Export PowerPoint"
      },
      "freeRegistration": "Sign up",
      "gallery": "Gallery",
      "generateWithAi": "Generate with AI",
      "history": "History",
      "imageSearch": "Image Search",
      "imageSearchPexels": "Image Search by Pexels",
      "imageSearchPixabay": "Image Search by Pixabay",
      "imprint": "Imprint",
      "learnMore": "Learn more",
      "legal": "Legal",
      "licenseInfo": "License Info",
      "logout": "Log out",
      "moreSettings": "More settings",
      "move": "Move",
      "moveToFolder": "Move to folder",
      "new": "Create",
      "open": "Open",
      "openAttachment": "Open attachment",
      "openRow": "Open {name}",
      "opensInNewTab": "opens in new tab",
      "overview": "Overview",
      "preview": "Preview",
      "print": "Print",
      "remix": "Remix",
      "remove": "Delete",
      "reportContent": "Report this content",
      "saveImage": "Save as image",
      "savePdf": "Save as PDF",
      "search": "Search",
      "settings": "Settings",
      "share": "Share",
      "showAll": "Show all",
      "showMore": "Show more",
      "showQrCode": "Show QR code",
      "signup": "Sign up",
      "templateToggle": "Use as template",
      "termsAndConditions": "T&Cs",
      "themeEditor": "Change Background",
      "toolInfos": "Tutorial and help",
      "tryNow": "Try now",
      "undiscard": "Restore",
      "uploadFile": "Upload file",
      "uploadImage": "Upload image"
    },
    "palette": {
      "colors": {
        "apricot": "Apricot",
        "gray": "Gray",
        "lavender": "Lavender",
        "lightBlue": "Light Blue",
        "lightGreen": "Light Green",
        "mauve": "Mauve",
        "mint": "Mint",
        "pink": "Pink",
        "salmon": "Salmon",
        "white": "White",
        "yellow": "Yellow"
      },
      "noColor": "No color",
      "noPattern": "No pattern"
    },
    "placeholders": {
      "anonymous": "Anonymous",
      "answer": "Enter answer...",
      "description": "Enter description...",
      "password": "Enter password...",
      "question": "Enter question...",
      "selectOption": "Please choose"
    },
    "preview": {
      "editLink": "Edit material",
      "hint": "You are currently viewing the preview.",
      "title": "Preview"
    },
    "profileStatus": {
      "licenses": {
        "courses": {
          "basic": {
            "label": "Courses Basic",
            "tooltip": "You can use the free training courses. If you want to access everything, we recommend the personal training flat rate or the training school license for the entire college."
          },
          "group": {
            "label": "Courses School License",
            "tooltip": "You have the advanced training school license. With it you can use all the training courses."
          },
          "pro": {
            "label": "Courses-Flatrate",
            "tooltip": "You have the training flat rate. With it you can use all the training courses."
          }
        },
        "tools": {
          "basic": {
            "label": "Tools Basic",
            "tooltip": "You can use the tools, but with a limit per tool. If you want to use all tools as much as you want, we recommend Tools Pro or the Tools School License."
          },
          "group": {
            "label": "Tools School License",
            "tooltip": "You have the Tools School License. With it you can use the tools without limit."
          },
          "pro": {
            "label": "Tools-Flatrate",
            "tooltip": "You have Tools-Flatrate access. With it you can use the tools without limit."
          }
        }
      }
    },
    "qrcodeModal": {
      "title": "QR Code"
    },
    "remixModal": {
      "alert": "The background knowledge for this assistant is not made available for remixing. You can easily add you own context.",
      "button": "Create your own remix",
      "licenseHint": "Disclaimer: This content is under the Creative Commons license CC-BY. This means you have to mention the author in your own work.",
      "loginPrompt": "Log in to your fobizz account to remix this content and use it for your own lessons.",
      "hint": "⏳ Note: For large materials, the remix may take some time - the process will keep running in the background. You'll find it later in your content overview.",
      "paragraph": "With a remix, you are creating your own copy of this content and can edit and customize it.",
      "toLogin": "Login to fobizz"
    },
    "response": {
      "labels": {
        "submission": "Submission | Submissions"
      }
    },
    "settingsModal": {
      "labels": {
        "autoCleanup": "{modelName} will be deleted after this period:"
      }
    },
    "shareOptions": {
      "buttons": {
        "create24hProject": "Shared space • 24 h",
        "createSchoolClass": "Shared space • 1 year",
        "selectProject": "Select shared space and project",
        "shareInSchoolClass": "Share in shared space",
        "showQRCode": "Show QR code"
      },
      "defaultNames": {
        "project24h": "Your 24h Project"
      },
      "hints": {
        "alreadyShared": "You have already shared this content in this shared space project. Please choose another project.",
        "error": "Error while updating your shared space. Please try again.",
        "errorShareSettings": "Error while updating your sharing settings. Please try again.",
        "locked": "Content locked. Only you can see and edit it.",
        "lockedInLibrary": "Content locked. Only you and the teachers at your school can view it.",
        "noSchoolClass": "You have not created a shared space yet. Create one now to share your content with your students.",
        "password_protected": "Share link is password protected.",
        "public_for_all": "Content is released as OER and published in the fobizz gallery.",
        "schoolClassWithoutProject": "You have not created a project in your shared space yet. Create one now to share your content with your students.",
        "secret": "Content is accessible via share link.",
        "sharedInClassroom": "Shared in your shared space",
        "invitedBy": "Invitation by {name}",
        "discardedByOwner": "Deleted by {name}",
        "success": "Successfully shared in your shared space",
        "successRemove": "Successfully removed from your shared space"
      },
      "labels": {
        "categories": "Categories",
        "iFrame": "Embed via iFrame",
        "project": "Project",
        "schoolClass": "Via shared space",
        "shareInSchoolClass": "Share in shared space",
        "shareLink": "Via share link",
        "shareSpace": "Shared space",
        "sharingSettings": "Sharing settings"
      },
      "options": {
        "select": "Select"
      }
    },
    "spinnerDialog": {
      "text": "Loading..."
    },
    "stockImageTypes": {
      "illustration": "Illustrations",
      "photo": "Photo",
      "vector": "Vector"
    },
    "templatesModal": {
      "emptyHint": "You have not save any templates yet.",
      "header": "Templates",
      "paragraph": "Start with your own or with a template provided by fobizz.",
      "tabFobizzTemplates": "fobizz templates",
      "tabYourTemplates": "Your templates"
    },
    "time": {
      "oClock": "o'clock",
      "today": "Today",
      "tomorrow": "Tomorrow"
    },
    "pseudonymModal": {
      "titles": {
        "pupil_feedback": "AI Feedback"
      }
    },
    "visitorPermissions": {
      "visitor_permissions_invisible": "Invisible",
      "visitor_permissions_read": "Read",
      "visitor_permissions_write": "Write"
    },
    "aiGenerated": {
      "label": "AI-generated",
      "tooltip": "This image was created with Artificial Intelligence"
    },
    "confirms": {
      "reRecord": {
        "confirm": "Discard & restart",
        "text": "Your current recording will be discarded so you can start a new one.",
        "title": "Restart recording?"
      },
      "unsavedChanges": {
        "discard": "Discard",
        "text": "You have unsaved changes. Do you want to save them?",
        "title": "Unsaved changes"
      }
    },
    "codeBlock": {
      "copied": "Copied!",
      "copyFailed": "Copy failed",
      "defaultFilename": "page",
      "download": "Download as HTML file",
      "fullscreen": "Fullscreen",
      "preview": "Preview",
      "reload": "Reload",
      "source": "Code"
    }
  }
}
